import React from "react";
import styles from "./InCallFeature.module.css";
import TitleBar from "../../TitleBar/TitleBar";

const InCallFeature = ({ fetchInCall }) => {
  const sections = (fetchInCall?.sections || []).map((s) => ({
    title: s?.title || "",
    desc: s?.desc || "",
    img: s?.img?.src || "",
    textWidth: s?.textWidth ?? `${s?.textWidthPct ?? 70}%`,
    leftOffset: s?.leftOffset ?? `${s?.leftOffsetPct ?? 10}%`,
  }));

  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>


        {/* Title Section */}
        <div className={styles.TitleSection}>
          <TitleBar blocks={fetchInCall.heading} />
        </div>


        <div className={styles.sectionWrapper}>
          {sections.map((sec, i) => (
            <div key={i} className={styles.section}>
              <div
                className={styles.text}
                style={{
                  width: sec.textWidth,
                  left: sec.leftOffset,
                }}
              >
                <h2>{sec.title}</h2>
                <p>{sec.desc}</p>
              </div>

              <div className={styles.FunnelShape}>
                <img src={sec.img} className={styles[`funnelImg${i + 1}`]} alt="" />
              </div>
            </div>
          ))}
        </div>
        <div className={styles.MobView}>
          <div className={styles.mobileContainer}>

            {/* Card 1 */}
            <div className={styles.mobileCard}>
              <div className={styles.leftSection}>
                <div className={styles.contentDiv}>
                  <h3>24×7 Availability</h3>
                  <p>After-hours availability, policies & schedules.</p>
                </div>
                <div className={styles.contentDiv}>
                  <h3>Concurrent Calls</h3>
                  <p>Parallel Call Answering and management</p>
                </div>
                <div className={styles.contentDiv}>
                  <h3>Multilingual Switching</h3>
                  <p>In-call switching to user preferred language</p>
                </div>
                <div className={styles.contentDiv}>
                  <h3>Smart Call Routing</h3>
                  <p>Warm call Transfers or Bookings</p>
                </div>

              </div>
              <div className={styles.rightSection}>
                <img src="/Svg/funnel-img.svg" className={styles.mobileImg} alt="funnel-img" />
              </div>

            </div>





          </div>
        </div>
      </div>
    </div>
  );
};

export default InCallFeature;
